import React from 'react';

/**
 * StagePipeline — Horizontal stage indicator (like a package tracker).
 * Shows all stages in the workflow with the current stage highlighted.
 */
export default function StagePipeline({ stages = [], currentStageId, compact = false }) {
  if (!stages.length) return null;

  const currentIdx = stages.findIndex(s => s.id === currentStageId);

  return (
    // Wraps instead of scrolling sideways — on a phone every step stays
    // visible without swiping (Oct 6).
    <div className="stage-pipeline" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: compact ? 4 : 8, rowGap: 8, padding: '8px 0' }}>
      {stages.map((stage, idx) => {
        const isCurrent = stage.id === currentStageId;
        const isPast = idx < currentIdx;
        const isTerminal = stage.stage_type === 'terminal';

        let bgColor = '#e5e7eb'; // future - gray
        let textColor = '#6b7280';
        if (isCurrent) {
          bgColor = stage.color || '#3b82f6';
          textColor = '#fff';
        } else if (isPast) {
          bgColor = stage.color || '#10b981';
          textColor = '#fff';
        }

        return (
          <React.Fragment key={stage.id}>
            {idx > 0 && (
              <div style={{
                width: compact ? 16 : 24,
                height: 2,
                backgroundColor: isPast || isCurrent ? (stages[idx - 1]?.color || '#10b981') : '#e5e7eb',
                flexShrink: 0,
              }} />
            )}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                padding: compact ? '4px 10px' : '6px 14px',
                borderRadius: 20,
                backgroundColor: bgColor,
                color: textColor,
                fontSize: compact ? 11 : 12,
                fontWeight: isCurrent ? 700 : 500,
                whiteSpace: 'nowrap',
                flexShrink: 0,
                border: isCurrent ? '2px solid rgba(0,0,0,0.15)' : '2px solid transparent',
                transition: 'all 0.2s',
              }}
              title={stage.sla_hours ? `SLA: ${stage.sla_hours}h` : undefined}
            >
              {isPast && <span>✓</span>}
              {isCurrent && !isTerminal && <span style={{ fontSize: 8 }}>●</span>}
              {stage.name}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
